import { render, staticRenderFns } from "./operatorRemarkDialog.vue?vue&type=template&id=b44323c2&"
import script from "./operatorRemarkDialog.vue?vue&type=script&lang=js&"
export * from "./operatorRemarkDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b44323c2')) {
      api.createRecord('b44323c2', component.options)
    } else {
      api.reload('b44323c2', component.options)
    }
    module.hot.accept("./operatorRemarkDialog.vue?vue&type=template&id=b44323c2&", function () {
      api.rerender('b44323c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/AirExport/components/routeCentral/operatorRemarkDialog.vue"
export default component.exports